import '../sass/site-motion.scss';
import { SiteMotion } from './utils/site-motion.mjs';

const initialize = () => {
    if (!document.body.classList.contains('ovalia-motion')) return;
    new SiteMotion(document).start();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
    initialize();
}
